export enum Role {
    Admin = 'oss_portal_admin',
    CatalogManagement = 'oss_portal_admin_catalog',
    Coverage = 'oss_portal_admin_coverage',
    Templates = 'oss_portal_admin_templates',
    FtthLoad = 'oss_portal_admin_ftth_load',
    Orders = 'oss_portal_orders',
    Products = 'oss_portal_products',
    Tasks = 'oss_portal_tasks',
    FullRelaunch ='oss_portal_tasks_full_relaunch',
    Resources = 'oss_portal_ftthResources',
    Catalog = 'oss_portal_catalog',
    Ftth = 'oss_portal_ftth',
    Mobile = 'oss_portal_mobile',
    CompleteProcess = 'oss_portal_complete_process',
    ReleaseTask = 'oss_portal_tasks_release',
    TaskManagement = 'oss_portal_task_management',
    MasterData = 'oss_portal_master_data',
    ChangePassword = 'oss_portal_change_password',
    PortOut = 'oss_portal_port_out'
}
